import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

import './TooltipContent.scss';
import { ButtonWithIcon } from '@els/els-react--button';

function TooltipContent({ header, onClose = () => {}, children }) {
  return (
    <div className="heatmap-tooltip-content">
      <header className="heatmap-tooltip-content__header">
        <InnerHTML tag="h4" html={header} />
        <ButtonWithIcon
          type="link"
          size="small"
          linkIconSize="s"
          sprite="Close"
          iconOnly
          onClick={onClose}
          className="els-btn-modal-close e2e-modal-close"
          aria-label="Close dialog box">
          Close
        </ButtonWithIcon>
      </header>
      {children}
    </div>
  );
}

TooltipContent.propTypes = {
  header: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default TooltipContent;
